module.exports = __webpack_public_path__ + "media/sessions/conference@1x-a6b0a094.png";